import { findField } from "../../../../utils/findField";
import { RowDimension, ScoresColumn } from "./scoresTable.types";
import { formatScoreValue, getMatchedColor } from "./scoresTableUtils";
import { EMPHASIZED_DIMENSION_CODES } from "./scoresTableConstants";

export const dimensionNameColumn: ScoresColumn = {
	id: "dimension",
	isVisible: () => true,
	getHeader: (context) => ({ label: findField(context.formatedFields, "instrument_dimension")?.headerName ?? "Dimensão" }),
	getCell: (row) => ({ content: { type: "text", value: row.instrument_dimension?.name ?? "" } }),
};

export const rawScoreColumn: ScoresColumn = {
	id: "rawScore",
	isVisible: (context) => context.rowsDimensions.some((row) => row.scores.raw_score != null),
	getHeader: (context) => ({ label: findField(context.formatedFields, "raw_score")?.headerName ?? "Pontuação Bruta", align: "center" }),
	getCell: (row) => ({ align: "center", content: { type: "text", value: formatScoreValue(row.scores.raw_score) } }),
};

export const calculatedScoreColumn: ScoresColumn = {
	id: "calculatedScore",
	isVisible: () => true,
	getHeader: (context) => ({ label: findField(context.formatedFields, "calculated_score")?.headerName ?? "Pontuação", align: "center" }),
	getCell: (row, _rowIndex, context) => ({
		align: "center",
		backgroundColor: getMatchedColor(row.matchedCutoff, context.levelColors),
		content: { type: "text", value: formatScoreValue(row.scores.calculated_score) },
	}),
};

export const isEmphasizedRow = (row: RowDimension) => {
	const code = row.instrument_dimension?.code;
	return code != null && EMPHASIZED_DIMENSION_CODES.includes(code);
};
